<template>
  <div id="app" @click="appAreaClicked">
    <!-- Placeholder for vue-notifyjs -->
    <notifications/>
    <!-- Placeholder for mqtt notifications -->
    <MqttDispatcher v-if="appReady"/>
    <AuthStatusTracker/>

    <!-- TODO this is just a layout demo for cookie consent
    <div id="cookie-consent" style="position: fixed; right: 0; bottom: 0; background-color: lightgoldenrodyellow; color: black;
z-index: 99; padding: 12px; text-align: center; font-family: 'Encode Sans', sans-serif; font-weight: 300;">
      This website is using cookies.
      View <a href="#" @click.stop="$store.dispatch('openPrivacyPolicyPopup')">Privacy Policy</a> for details.
      <v-icon>close</v-icon>
    </div>
    -->

    <v-app light>

      <!-- TODO refactor this to pfx-dialog component -->
      <v-dialog :lazy="true" :fullscreen="dialog.fullscreen" :width="dialog.width" v-model="dialog.visible">
        <v-card flat style="padding:1rem;">
          <div v-if="dialog.xCloseIcon" style="position: absolute; top: 1em; right: 1em; cursor: pointer;" @click="closeDialog()"><v-icon>close</v-icon></div>
          <v-card-title v-if="dialog.title" class="headline">{{ dialog.title }}</v-card-title>
          <v-card-text v-if="dialog.html" v-html="dialog.html" />
          <v-card-text v-else-if="dialog.text" v-html="$options.filters.convertLinebreaks(dialog.text)" />
          <v-card-text v-else-if="dialog.staticContent"><StaticContentPage :content="dialog.staticContent" /></v-card-text>
          <v-card-actions v-if="dialog.buttons && dialog.buttons.length > 1">
            <template v-for="(b, index) in dialog.buttons">
              <v-spacer v-if="index !== 0" :key="b.title" />
              <button @click="closeDialog(b.handler)" :key="b.title" :class="b.class">{{ b.title }}</button>
            </template>
          </v-card-actions>
          <v-card-actions v-else>
            <template v-for="b in dialog.buttons">
              <v-spacer :key="b.title" />
              <button @click="closeDialog(b.handler)" :key="b.title" :class="b.class">{{ b.title }}</button>
            </template>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog :lazy="true" :width="1024" v-model="getStartedDialog.visible">
        <GetStarted :visible="getStartedDialog.visible" />
      </v-dialog>

      <v-dialog :lazy="false" width="640" v-model="youTubeDialog.visible">
        <v-card>
          <div id="youTubePlayerElement"></div>
        </v-card>
      </v-dialog>

      <LoadingSpinner :visible="appLoading || $store.state.loadingSpinner" />
      <div v-if="initFailed" style="padding: 5rem; text-align: center; font-size: 24px; line-height: 1.25em; font-weight: 300; color: #666; font-family: 'Encode Sans', sans-serif;">
        We are currently having a service break.<br/>
        Please try again a bit later.<br/>
      </div>

      <div v-if="appReady" class="page-container">
        <ThemeWrapper :theme="$store.state.theme">

          <!-- TODO refactor to own component -->
          <v-dialog transition="dialog-bottom-transition" v-model="loginDialog.visible" max-width="480px">
            <v-card>
              <Login />
            </v-card>
          </v-dialog>

          <MainHeader v-if="!$route.meta.noHeader" />
          <router-view class="router-wrap"></router-view>
          <MainFooter v-if="!$route.meta.noFooter" />

        </ThemeWrapper>
      </div>

    </v-app>
  </div>
</template>

<script>
  import MainHeader from './components/elements/MainHeader.vue'
  import MainFooter from './components/elements/MainFooter.vue'
  import Login from './components/Login.vue'
  import ThemeWrapper from './components/elements/ThemeWrapper.js'
  import StaticContentPage from './components/StaticContentPage.vue'
  import { parseTenantSubdomain } from './utils/PfxUtils.js'
  import LoadingSpinner from './components/elements/LoadingSpinner.vue'
  import MqttDispatcher from './components/elements/MqttDispatcher.vue'
  import AuthStatusTracker from './components/elements/AuthStatusTracker.vue'
  import GetStarted from './components/GetStarted'

  const INIT_TENANT = 'INIT_TENANT'
  const INIT_USER_SERVICE = 'INIT_USER_SERVICE'
  const INIT_CORE_SERVICE = 'INIT_CORE_SERVICE'
  const VERSION = '1.0.41'

  export default {
    name: 'App',
    components: {
      GetStarted,
      MainHeader,
      MainFooter,
      Login,
      ThemeWrapper,
      StaticContentPage,
      LoadingSpinner,
      MqttDispatcher,
      AuthStatusTracker
    },
    data () {
      return {
        initActions: [ INIT_TENANT, INIT_USER_SERVICE, INIT_CORE_SERVICE ],
        initFailed: false,
        dialog: {},
        loginDialog: {},
        getStartedDialog: {},
        youTubeDialog: {},
        youTubePlayer: null
      }
    },
    computed: {
      appLoading() {
        return this.initActions.length > 0
      },
      appReady() {
        return !this.appLoading && !this.initFailed
      },
      dialogVisibleUpdated() {
        return this.$store.state.dialog.visible
      },
      loginDialogVisibleUpdated() {
        return this.$store.state.loginDialog.visible
      },
      getStartedDialogVisibleUpdated() {
        return this.$store.state.getStartedDialog.visible
      },
      youTubeDialogVisibleUpdated() {
        return this.$store.state.youTubeDialog.visible
      }
    },
    watch: {
      dialogVisibleUpdated() {
        this.dialog = this.$store.state.dialog
      },
      loginDialogVisibleUpdated() {
        this.loginDialog = this.$store.state.loginDialog
      },
      getStartedDialogVisibleUpdated() {
        this.getStartedDialog = this.$store.state.getStartedDialog
      },
      youTubeDialogVisibleUpdated() {
        this.youTubeDialog = this.$store.state.youTubeDialog
        if (this.youTubeDialog.visible) {
          this.youTubePlayer.loadVideoById({ videoId: this.youTubeDialog.videoId })
        } else {
          this.youTubePlayer.stopVideo()
        }
      },
      '$route.path'() {
        // if need to react to route (page) changes
      }
    },
    created() {
      console.log('environment configuration!', process.env.config)
      console.log('Version: ' + VERSION)

      let scriptTag = document.getElementById('youtube_player_api_script')
      if (!scriptTag) {
        scriptTag = document.createElement('script')
        scriptTag.src = 'https://www.youtube.com/player_api'
        scriptTag.id = 'youtube_player_api_script'
        const headElement = document.getElementsByTagName('head')[0]
        headElement.appendChild(scriptTag)
      }
      this.initYouTube()

      this.$PfxBackendApi.getUserServiceMonitor().then(res => {
        console.debug('getUserServiceMonitor', res)
        this.initActionDone(INIT_USER_SERVICE)
      }).catch(err => {
        console.error('getUserServiceMonitor failed', err)
        this.initFailure()
      })

      this.$PfxBackendApi.getCoreServiceMonitor().then(res => {
        console.debug('getCoreServiceMonitor', res)
        this.initActionDone(INIT_CORE_SERVICE)
      }).catch(err => {
        console.error('getCoreServiceMonitor failed', err)
        this.initFailure()
      })

      this.$store.commit('clearNewAuctionStorage')
      this.$store.dispatch('authorize', { router: this.$router })

      const subdomain = parseTenantSubdomain()
      if (subdomain === '#pfx') {
        this.$store.commit('setTenant', { subdomain: subdomain, status: 'ACTIVE', data: {} })
        this.initActionDone(INIT_TENANT)

      } else {
        this.$PfxBackendApi.getTenantStatus(subdomain).then(res => {
          console.log('getTenantStatus res', res)
          const tenantStatus = (res.data && res.data.status) || 'UNKNOWN'

          let tenantProfileData = {}
          this.$PfxBackendApi.getTenantPublic(subdomain).then(res => {
            console.debug('getTenantPublic', res)
            tenantProfileData = res.data || {}
            this.$vuetify.theme.brand = tenantProfileData.brandColor || '#00b9ef'
            this.$store.commit('setBrandColor', tenantProfileData.brandColor || '#00b9ef')
            this.$store.commit('setShowBannerOverlay', tenantProfileData.showBannerOverlay || true)
          }).catch(err => {
            console.error('getTenantPublic failed', err)
          }).then(() => {
            this.$store.commit('setTenant', { subdomain: subdomain, status: tenantStatus, data: tenantProfileData })
            this.initActionDone(INIT_TENANT)
          })

        }).catch(err => {
          if (err.status === 404) { // invalid subdomain, tenant not existing
            document.location = process.env.config.frontend.pfxLandingPage
            return
          }
          console.error('getTenantStatus failed', err)
          this.initFailure()
        })
      }
    },
    mounted() {
    },
    methods: {
      initYouTube() {
        if (window.youTubeIframeAPIReady) {
          // eslint-disable-next-line no-undef
           this.youTubePlayer = new YT.Player('youTubePlayerElement', { height: '360', width: '640' })
        } else {
          setTimeout(() => this.initYouTube(), 100)
        }
      },
      closeDialog(handler) {
        if (handler && typeof handler === 'function') {
          handler()
        } else {
          this.$store.commit('closeDialog')
        }
      },
      initActionDone(action) {
        const index = this.initActions.indexOf(action)
        if (index >= 0) {
          this.initActions.splice(index, 1)
        }
      },
      initFailure() {
        this.initActions = []
        this.initFailed = true
      },
      appAreaClicked() {
        if (this.$store.state.headerMenuVisible) {
          this.$store.state.headerMenuVisible = false
        }
      }
    }
  }
</script>

<style lang="scss">
  //@import 'node_modules/jeet/scss/index';
  @import './pfx.scss';
  .router-wrap{
    min-height: calc(100vh - 444px);
  }
  html{
    font-size: 100%;
  }
  body {
    margin: 0;
    padding: 0;
    background-color: $color-pure-white;
    font-size: 14px;
  }

  body, textarea, .application {
    font-family: 'Nunito Sans', sans-serif;
  }

  * {
    box-sizing: border-box;
  }

  .list-bullets{
    word-break: break-all;
  }

  img.fullwidth {
    width: 100%;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    li {
      margin: 0;
    }
  }

  .list-bullets ul, ul.list-bullets {
    list-style: square;
    li {
      margin-left: 1.5rem;
    }
    li:last-child {
      margin-bottom: 1rem;
    }
  }
  ul.list-bullets.no-margin {
    li:last-child { margin-bottom: 0 }
  }

  ol {
    li {
      margin-left: 1.5rem;
    }
  }

  h1,
  h2,
  h3,
  h4 {
    margin-top: .5rem;
    margin-bottom: .5rem;
  }

  p {
    margin-top: 0;
    word-break: overflow-wrap;
  }

  h1 {
    font-weight: 300;
    font-size: 2.5rem;
    line-height: 2.5rem;
    margin-bottom: 1rem;
  }
  h3 {
    font-size: 1rem;
  }

  h1.above-menu {
    font-size: 1.8rem;
    font-weight: 400;
    font-family: 'Encode Sans', sans-serif;
  }

  a {
    color: $color-pfx-brand;
    text-decoration: underline;
    &:hover {
      color: black;
    }
  }
  a.alt-link {
    text-decoration: none;
    &:hover {
      text-decoration: underline;
      color: $color-pfx-brand;
    }
  }

  a.alt-link-cookie-banner {
    text-decoration: none;
    color: blue;
    &:hover {
      text-decoration: underline;
      color: blue;
    }
  }

  a.no-underline {
    text-decoration: none;
  }

  button, .button {
    border: 0;
    padding: 0.5em 1em;
    background-color: $color-pfx-brand;
    color: $color-white;
    cursor: pointer;
    position: relative;
    border-radius: 3px;
    &:hover {
      background-color: #025c95;
    }
    a {
      color: inherit;
      text-decoration: none;
      &:hover {
        color: inherit;
      }
    }
  }
  button.wider {
    padding-left: 5em;
    padding-right: 5em;
  }
  button.wide {
    width: 100%;
  }
  button.fat {
    margin-top: 12px;
    padding: 12px 60px;
    box-shadow: 0 2px 20px rgba(#000, .5);
  }
  button.btn-rounded {
    border-radius: 8px;
  }
  button.btn-neutral {
    background-color: #4a4a4a;
    color: $color-white;
    &:hover {
      background-color: #3a3a3a;
    }
  }
  button.btn-neutral-dark {
    background-color: #616161;
    color: $color-white;
    &:hover {
      background-color: #3a3a3a;
    }
  }
  button.btn-neutral-light {
    background-color: #F0EEE6;
    color: black;
    &:hover {
      background-color: #aeaeae;
    }
  }
  button.btn-invisible {
    background-color: rgba(0,0,0,0);
    color: #666;
    text-decoration: underline;
    &:hover {
      background-color: rgba(100,100,100,0.1);
    }
  }
  button.btn-danger {
    background-color: #b71c1c;
    &:hover {
      background-color: #a70c0c;
    }
  }
  button.btn-green {
    background-color: #4CAF50;
    &:hover {
      background-color: #43A047;
    }
  }
  button.btn-small {
    font-size: 0.85em;
  }
  button:disabled {
    opacity: 0.25;
    cursor: not-allowed;
  }

  fieldset {
    border: 0;
    margin: 0;
    padding: 0 0 1rem;
  }

  .red-text {
    color: darkred;
  }
  .error-message {
    color: $color-error-text;
  }

  div.p {
    margin-bottom: 1em;
  }

  .fade-enter-active {
    transition: all .2s ease-out;
  }
  .fade-leave-active {
    transition: all .2s ease-out;
  }
  .fade-enter {
    opacity: 0;
    //transform: translateX(200px);
  }
  .fade-leave-to {
    opacity: 0;
    //transform: translateX(-200px);
  }
  // .page-fade-enter-active {
  //   //transition: all .4s ease-out;
  // }
  // .page-fade-leave-active {
  //   //transition: all .3s ease-out;
  // }
  // .page-fade-enter {
  //   //opacity: 0;
  //   //transform: scale(2.05)
  // }
  // .page-fade-leave-to {
  //   //opacity: 0;
  //   //transform: scale(.95)
  // }

  input {
    padding: .5rem;
  }
  input, textarea, select {
    display: block;
    margin: 0;
    border: 1px solid #ccc;
    font-size: 1rem;
    width: 100%;
    background-color: $color-pure-white;
  }
  input:disabled, textarea:disabled, input.readonly {
    background-color: transparent;
    color: #888;
    cursor: not-allowed;
  }
  input[type="number"] {
    width: 100%;
  }
  input[type="radio"], input[type="checkbox"] {
    display: inline;
    width: auto;
  }
  input[type="file"] {
    border: 0;
    padding: 0.5em 0;
    background-color: inherit;
  }
  input.error {
    border-color: $color-error-text;
    background-color: inherit !important;
  }
  select {
    padding: 0.5rem;
    width: auto;
    appearance: menulist;
  }
  option, textarea {
    padding: 0.5rem;
  }
  // hack to get the shadows play nice with wide input filds
  .menu__content{
    box-shadow: none!important;
    >div{
      box-shadow:0 0 15px rgba(0,0,0,.2);
      margin: 10px;
      margin-top: 0;
    }
  }
  .pfx-selectbox{
    display: block;
    position: relative;
  }
  .pfx-selectbox select{
    appearance: none;
    position: relative;
    width: 100%;
  }
  .pfx-selectbox:after{
    content: "";
    position: absolute;
    right: 10px;
    top: 40%;
    background-image: url('./assets/select-arrow.png');
    background-size: contain;
    background-repeat: no-repeat;
    width: 15px;
    height: 20px;
    pointer-events: none;
  }
  hr {
    border: 0.5px solid #b4b4b4;
  }

  .clearfix {
    @include clearfix();
  }

  .container {
    position: relative;
    @include clearfix();
    max-width: $content-width;
    padding: 0 1em;
    margin: 0 auto 5rem;
    @include tablet-portrait-breakpoint {
      padding: 0 1rem;
    }
    @include desktop-large-breakpoint {
      padding: 0 1rem;
    }
  }
  .container-thin {
    margin-bottom: 1rem;
  }

  span.space {
    display: inline-block;
    width: 1em;
  }

  .debug {
    font-style: italic;
    font-size: 10px;
  }

  .user-avatar {
    border-radius: 50%;
  }

  .create-listing-progress-menu {
    @include stack();
    @include tablet-landscape-breakpoint {
      @include column(1/5)
    }
  }
  .create-listing-content {
    @include stack();
    @include tablet-landscape-breakpoint {
      @include column(4/5)
    }
  }
  .create-listing-form {
    select {
      width: 100%;
    }
  }

  .grey-box-container {
    background-color: $grey-box-bg;
    border-radius: 14px;
    box-shadow: 0 2px 4px 0 rgba(189, 189, 189, 0.5);
    margin-bottom: 1rem;
    padding: 1rem 1.5rem;

    h2 { margin-top: 0; }
  }

  .data-table-property-info {
    margin: .5rem .5rem .5rem 0;

    .photo-container {
      float: left;
      margin: 0 1rem 0 0;
      width: 85px;
      height: 68px;
      max-width: 100%;
      position: relative;
      background-size: cover;
      background-position: center;
    }
    .data-container {
      margin-left: 100px;
      line-height: 1.25em;
      color: #4a4a4a;
      .address {
        font-family: 'Encode Sans', sans-serif;
        font-weight: 400;
        font-size: 14px;
        line-height: 1.5em;
        color: #000;
      }
    }
  }
  .data-table-company-logo {
    width: 33px;
  }
  .dashboard {
    .sub {
      font-size: 11px;
      font-weight: 600;
      color: #777;
      text-transform: uppercase;
    }
    .margin-top {
      margin-top: .5rem;
    }
    .data-table-expanded-row {
      background-color: #f6fafc;
      td.data-container {
        height: 150px;
      }
    }
  }

  .pointer { cursor: pointer; }
  .align-left { text-align: left !important; }
  .align-right { text-align: right !important; }
  .align-center { text-align: center !important; }
  .nowrap { white-space: nowrap; }

  .new-chip {
    display: inline-block;
    background-color: #b4ec51;
    background-image: linear-gradient(to bottom, #b4ec51, #429321);
    color: #000;
    border-radius: 12px;
    text-align: center;
    padding: .25em 2em;
    margin-bottom: .5rem;
  }

  .winner-chip {
    display: inline-block;
    background-color: $color-gold;
    background-image: $gradient-gold;
    color: #000;
    border-radius: 12px;
    text-align: center;
    padding: .25em 2em;
    margin-top: .5rem;
    font-size: 0.8rem;
    font-weight: 600;
    a {
      color: inherit;
    }
  }

  .faq-question-container {
    position: relative;

    h2 {
      font-size: 14px;
      font-weight: 600;
      border-bottom: 1px solid #dadada;
      padding: .5rem .5rem;
      cursor: pointer;
    }
    div {
      font-size: 12px;
      padding: .5rem 1rem .5rem .5rem;
      display: none;
    }
  }

  // start of B2B page styles
  .split-view {

    .column {
      @include stack();

      @include tablet-portrait-breakpoint {
        @include column(1/2, $cycle: 2, $gutter: 0);
      }
    }

    .column.text-padding {
      padding: 20px 40px 40px;
      @include tablet-landscape-breakpoint {
        padding: 117px 47px 40px;
      }
      background-color: #fff;
      color: #000;
    }
    .column.image-padding {
      @include tablet-landscape-breakpoint {
        padding: 30px;
      }
    }

    h2 {
      font-family: 'Encode Sans', sans-serif;
      font-size: 24px;
      line-height: 30px;
      font-weight: 600;
    }
    p {
      font-size: 16px;
      font-weight: 400;
    }
    li {
      .icon {
        margin-right: 18px;
      }
      font-size: 16px;
      font-weight: 400;
      line-height: 2;
    }
    img.screenshot {
      width: 100%;
    }
    img.screenshot.shadow {
      box-shadow: 0 2px 4px #ccc;
    }
    .integrations img {
      height: 32px;
      margin-right: 24px;
    }
  }

  .three-column {
    @include stack();
    @include tablet-landscape-breakpoint {
      @include column(1/2, $cycle: 2);
    }
    @include tablet-portrait-breakpoint {
      @include column(1/3, $cycle: 3);
    }
  }

  .videos {
    .column {
      @include stack();
      height: 256px;
      color: #fff;
      position: relative;
      @include tablet-portrait-breakpoint {
        @include column(1/2, $cycle: 2, $gutter: 0);
      }
      @include tablet-landscape-breakpoint {
        @include column(1/4, $cycle: 4, $gutter: 0);
      }
    }
    .video1 {
      background-color: #15252a;
      padding: 60px 45px;
    }
    .video2 {
      background-color: #157691;
    }
    .video3 {
      background-color: #15252a;
    }
    .video4 {
      background-color: #ababab;
    }
    .title {
      position: absolute;
      bottom: 20px;
      left: 20px;
      font-family: 'Encode Sans', sans-serif;
      font-size: 16px;
      font-weight: 600;
    }
    .length {
      margin-top: 8px;
    }
    .play {
      position: absolute;
      bottom: 20px;
      right: 20px;
      background-image: url('./assets/play-icon.svg');
      background-size: cover;
      height: 32px;
      width: 32px;
    }
  }
  // end of B2B page styles

  // fix that vue-notifyjs notifications (by default z-index: 100) will appear above fullscreen vue-dialogs (that has z-index: 202)
  .vue-notifyjs {
    .alert {
      z-index: 1000;
      box-shadow: none !important;
      opacity: 0.85;
    }
    // custom colors
    .alert.alert-primary { background-color: #444; }
    .alert.alert-info { background-color: #444; }
    .alert.alert-success { background-color: seagreen; }
    .alert.alert-warning { background-color: darkorange; }
    .alert.alert-danger { background-color: darkred; }
  }

  // override vuetify big radiobutton labels
  .input-group { label { font-size: inherit; color: black !important; } }

  .label-sidenote {
    color: #8A8A8A;
    font-style: italic;
  }
  // override vuetify select styles
  .input-group--select {
    .input-group--select__autocomplete {
      border: none !important;
      background: transparent;
    }
  }
  .application.theme--light {
    background-color: $color-pure-white;
    color: #000;
  }
  // override vuetify auto-prefill input select/text box
  .input-group--text-field input,
  .input-group--select .input-group__selections__comma {
    font-size: inherit;
  }
  // override vuetify v-dialog styles
  .dialog {
    border-radius: 8px;
  }
  // override vuetify v-data-table styles (make background transparent)
  .application .table {
    background: transparent;
    thead th,
    tbody td {
      padding: 0 6px !important;
    }
  }
  // override vuetify v-data-table styles for dashboard
  .application .dashboard .table.datatable {
    margin: 12px 0 48px;
    thead {
      tr {
        border: 1px solid #f7f7f7;
        border-bottom: 0;
        height: 39px;
        th {
          background-color: #EBF2F6;
          font-weight: 600;
          text-transform: uppercase;
          color: #000;
        }
      }
    }
    tbody {
      tr {
        border: 1px solid #f7f7f7;
        border-top: 0;
      }
    }
    thead th,
    tbody td {
      padding: 0 12px !important;
    }
  }
  // override vuetify stepper styles
  .application .theme--light.stepper {
    background: transparent;
    box-shadow: none;
    .stepper__content {
      border-left: 1px solid #9b9b9b !important;
    }
    .stepper__step {
      .stepper__label {
        font-size: 16px;
        font-weight: 600;
      }
    }
    .stepper__step--complete {
      .stepper__step__step {
        background-color: white !important;
        .icon {
          color: #555;
        }
      }
      .stepper__label {
        color: white;
      }
    }
    .stepper__step--active {
      .stepper__step__step {
        color: black;
        background-color: white !important;
      }
      .stepper__label {
        color: white;
      }
    }
    .stepper__step--inactive {
      .stepper__step__step {
        color: #555;
        background-color: #9b9b9b !important;
      }
      .stepper__label {
        color: #9b9b9b;
      }
    }
  }
  .application .theme--light.stepper.stepper--vertical {
    .stepper__step {
      padding: 24px 0 16px;
    }
    .stepper__content {
      margin: -16px 12px -24px;
    }
  }

  // start of tooltip styles
  .tooltip {
    display: block !important;
    z-index: 101;
    .tooltip-inner {
      background: #FAFFF9;
      color: black;
      border-radius: 5px;
      padding: 1rem 1.5rem;
      box-shadow: 0 2px 8px 0 rgba(107, 107, 107, 0.5);
      max-width: 300px;
    }
    .tooltip-arrow {
      width: 0;
      height: 0;
      border-style: none;
      position: absolute;
      margin: 5px;
      border-color: white;
      z-index: 1;
    }
    &[x-placement^="top"] {
      margin-bottom: 5px;
      .tooltip-arrow {
        border-width: 5px 5px 0 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        bottom: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
      }
    }
    &[x-placement^="bottom"] {
      margin-top: 5px;
      .tooltip-arrow {
        border-width: 0 5px 5px 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        top: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
      }
    }
    &[x-placement^="right"] {
      margin-left: 5px;
      .tooltip-arrow {
        border-width: 5px 5px 5px 0;
        border-left-color: transparent !important;
        border-top-color: transparent !important;
        border-bottom-color: transparent !important;
        left: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
      }
    }
    &[x-placement^="left"] {
      margin-right: 5px;
      .tooltip-arrow {
        border-width: 5px 0 5px 5px;
        border-top-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        right: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
      }
    }
    &[aria-hidden='true'] {
      visibility: hidden;
      opacity: 0;
      transition: opacity .15s, visibility .15s;
    }
    &[aria-hidden='false'] {
      visibility: visible;
      opacity: 1;
      transition: opacity .15s;
    }
    &.info {
      $color: rgba(#004499, .9);
      .tooltip-inner {
        background: $color;
        color: white;
        padding: 24px;
        border-radius: 5px;
        box-shadow: 0 5px 30px rgba(black, .1);
      }
      .tooltip-arrow {
        border-color: $color;
      }
    }
    &.popover {
      $color: #f0f0f0;
      .popover-inner {
        background: $color;
        color: black;
        padding: 1.25rem;
        border-radius: .25rem;
        box-shadow: 0 5px 30px rgba(black, .2);
        max-width: 30rem;
      }
      .popover-arrow {
        border-color: $color;
      }
    }
  }
  // end of tooltip styles

</style>



// WEBPACK FOOTER //
// src/App.vue